import React from 'react'
import { Input, CustomInput } from 'reactstrap';
import Aux from '../Hoc'

const FormInput = (props) => {
    let inputElement = null;
    const inputClasses = [];

    if (props.invalid && props.shouldValidate && props.submitted) {
        inputClasses.push('invalid')
    }


    switch (props.type) {
        case ('text' || 'number' || 'textarea'):
            inputElement = <Input
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.changed}
            />
            break;

        case ('hidden'):
            inputElement = <Input
                type={props.type}
                name={props.name}
                value={props.value}
            />
            break;

        case ('plaintext'):
            inputElement = <Input
                type={'text'}
                name={props.name}
                value={props.value}
                disabled
            />
            break;

        case ('select'):
            inputElement =

                (<Input
                    className={inputClasses.join(' ')}
                    type={props.type}
                    name={props.name}
                    id={props.name}
                    value={props.value}
                    onChange={props.changed}
                >
                    <option className="text-capitalize" key={0} value=''>Select</option>
                    {
                        props.data.options.map(
                            (option, i) => {
                                if (props.name == props.selects[0]) {
                                    return <option className="text-capitalize" key={i} value={option[props.selectKey[0]]}> {option[`${props.selects[0]}`]} </option>
                                }
                                else if (props.name == props.selects[1]) {
                                    return <option className="text-capitalize" key={i} value={option[props.selectKey[1]]}> {option[`${props.selects[1]}`]} </option>
                                }
                                else if (props.name == props.selects[2]) {
                                    return <option className="text-capitalize" key={i} value={option[props.selectKey[2]]}> {option[`${props.selects[2]}`]} </option>
                                }

                            }
                        )
                    }
                </Input>);
            break;


        default:
            inputElement = <Input
                className={inputClasses.join(' ')}
                type={props.type}
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.changed}
                min={props.min}
                max={props.max}
            />
    }

    return (
        <Aux>





            {

                (props.required && props.invalid && props.submitted) &&
                <div className="col-12">
                    <p className="text-right text-danger mb-0 ">*{props.label}
                        &nbsp;{props.error}</p>
                </div>
            }

            {

                (props.fieldError && !props.isFieldValid && !props.invalid) &&
                <div className="col-12">
                    <p className="text-right text-danger mb-0 ">*{props.label}
                        &nbsp;{props.fieldError}</p>

                </div>
            }

            {
                props.type !== 'checkbox' &&
                <div className={" pt-2 h6 text-uppercase pl-md-3 pl-0 col-4 "}
                    htmlFor={props.name}

                    size="sm">{props.label}
                    {
                        props.required &&
                        <span className="text-danger">*</span>
                    }
                </div>
            }

            {
                props.type !== 'checkbox' &&
                <div className={" pl-0 pr-md-3 pr-0 col-8 "}
                >
                    {inputElement}
                </div>
            }




            {
                props.type === 'checkbox' &&
                <div className="" key={`${props.value}asdadsa`}>

                    <CustomInput className="" type="checkbox" id={props.label} label={props.label.replace(/\s+/g, '\u00A0')} onChange={props.changed} checked={props.value === '' || props.value === false || props.value === 'false' || props.value === null || props.value === 'No' ? false : true} inline />
                </div>
            }

        </Aux>
    );
}

export default FormInput;


// WEBPACK FOOTER //
// ./src/_components/common/Form/formInput.jsx